export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ee08f5e0-b153-4f09-be91-c7d3999aabcd/artifacts/zzxbb5af_Logo.png";

export const BUSINESS = {
  name: "Spotless Water Works",
  tagline: "Pure Water. Perfect Results.",
  phone: "954-833-4888",
  phoneHref: "tel:+19548334888",
  email: "Info@SpotlessWaterWorks.com",
  areas: [
    "West Palm Beach",
    "Boca Raton",
    "Delray Beach",
    "Boynton Beach",
    "Jupiter",
    "Fort Lauderdale",
    "Pompano Beach",
    "Hollywood",
    "Aventura",
    "Doral",
    "Coral Gables",
    "Miami",
  ],
  hours: "Mon–Sat · 7:00 AM – 7:00 PM",
};

export const SERVICES = [
  {
    id: "house-washing",
    title: "House Washing",
    blurb:
      "Soft-wash exterior cleaning that lifts mildew, algae and salt residue without touching a single shingle.",
    icon: "Home",
    featured: true,
  },
  {
    id: "roof-cleaning",
    title: "Roof Cleaning",
    blurb:
      "Low-pressure roof treatments that kill black streaks (Gloeocapsa magma) and extend shingle life.",
    icon: "Umbrella",
  },
  {
    id: "gutter-care",
    title: "Gutter Care",
    blurb:
      "Flush, degrease and brighten gutters + downspouts. Say goodbye to tiger-stripe streaks.",
    icon: "CloudRain",
  },
  {
    id: "driveways",
    title: "Driveways & Concrete",
    blurb:
      "Surface-cleaner passes + spot treatments to blast oil, rust and years of grime out of the pores.",
    icon: "Car",
    featured: true,
  },
  {
    id: "solar",
    title: "Solar Panel Cleaning",
    blurb:
      "Purified deionized water rinse restores panel output — up to 20% more energy generation.",
    icon: "Sun",
  },
  {
    id: "fleet",
    title: "Fleet & Van Cleaning",
    blurb:
      "On-site fleet detailing for commercial vans, trucks and trailers. Keep your brand spotless.",
    icon: "Truck",
  },
  {
    id: "pool-cage",
    title: "Pool Cages & Screens",
    blurb:
      "Gentle, thorough screen enclosure cleaning — no torn mesh, no streaks.",
    icon: "Waves",
  },
  {
    id: "boat",
    title: "Boat Cleaning",
    blurb:
      "Salt, algae and waterline stains washed off hulls, decks and canvas — dockside or at the marina.",
    icon: "Ship",
  },
  {
    id: "commercial",
    title: "Commercial & HOA",
    blurb:
      "Storefronts, sidewalks, dumpster pads, parking garages. Scheduled maintenance available.",
    icon: "Building2",
    featured: true,
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus D.",
    city: "Boca Raton, FL",
    quote:
      "Our driveway hadn't looked this good since we poured it. The team showed up on time, treated the whole thing, and the concrete looks brand new.",
    rating: 5,
  },
  {
    name: "Priya S.",
    city: "Fort Lauderdale, FL",
    quote:
      "Booked a house wash + roof soft-wash. The black streaks are gone. Neighbors are asking who we used. Worth every dollar.",
    rating: 5,
  },
  {
    name: "Jordan T.",
    city: "Miami Beach, FL",
    quote:
      "We had them clean our delivery van fleet — 6 vehicles, all done at our lot. Fast, professional, and cheaper than the car wash route.",
    rating: 5,
  },
  {
    name: "Elena R.",
    city: "West Palm Beach, FL",
    quote:
      "Solar panels were caked with dust and pollen. After Spotless came out, our monthly production went up noticeably. No brainer.",
    rating: 5,
  },
];

// Before/after pairs — same photograph, with a "dirty" CSS filter applied
// to the "before" state. Guarantees identical composition.
export const BEFORE_AFTER = [
  {
    id: "ba-house",
    label: "House Exterior · Delray Beach",
    image:
      "https://images.unsplash.com/photo-1693837851506-93d3d01d4f44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxmbG9yaWRhJTIwaG91c2UlMjBleHRlcmlvcnxlbnwwfHx8fDE3ODM0ODAyNTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ba-drive",
    label: "Driveway · Boca Raton",
    image:
      "https://images.unsplash.com/photo-1605146768851-eda79da39897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGRyaXZld2F5fGVufDB8fHx8MTc4MzQ4MDI1NXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ba-roof",
    label: "Roof · Fort Lauderdale",
    image:
      "https://images.unsplash.com/photo-1518780664697-55e3ad937233?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const STATS = [
  { value: "500+", label: "Homes Washed" },
  { value: "4.9★", label: "Google Rating" },
  { value: "100%", label: "Insured & Licensed" },
  { value: "24hr", label: "Avg. Response" },
];
